<template>
  <ModalContainer queryParam="exe" ref="modalContainer">

    <b-card class="mb-0">

      <h3 class="modal-title">Ejecutar Proceso</h3>
      <div class="my-3">
        <label for="fecha-ejecucion">Fecha Ejecucion:</label>
        <input 
          id="fecha-ejecucion" 
          type="date" 
          v-model="fechaEjecucion" 
          class="form-control" 
        />
      </div>

      <div class="d-flex justify-content-end">
        <b-button variant="secondary"> 
          Cancelar 
        </b-button>

        <b-button 
          variant="primary"
          @click="ejecutarProceso"
          class="ml-1"
        > 
          Ejecutar 
        </b-button>
      </div>
    </b-card>
    
  </ModalContainer>
  
</template>


<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { ModalContainer } from "@/shared/components";
import { procedimientosService } from "../services";

export default {

  name: "EjecutarProceso",

  components: {
    ModalContainer
  },

  data(){
    return {
      tokenProceso: null,
      fechaEjecucion: null,
    }
  },


  created(){
    this.getData();
  },


  methods: {


    async getData(){
      this.fechaEjecucion = null;

      this.tokenProceso = this.$route.query.exe;
      if(!this.tokenProceso) return;

      const responseData = await procedimientosService.getByToken(this.tokenProceso);
      if (!responseData || !responseData.fechaProgramada) return;

      if(responseData.estadoProceso !== 'ejecutada') return
      this.fechaEjecucion = responseData.fechaProgramada;
    },


    async ejecutarProceso() {
      if (this.tokenProceso) {

        const ejeconfirmation = await this.$swal({
          title: "¿Estás seguro de ejectuar el proceso clinico?",
          text: "No podrás deshacer esta acción.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, actualizar",
          cancelButtonText: "Cancelar",
        });

        if (ejeconfirmation.isConfirmed) {
          const query = `
            mutation ejecutarProceso(
              $tokenProceso     : String!, 
              $fechaEjecucion: String!
            ) {
              ejecutarProceso(
                tokenProceso  : $tokenProceso, 
                fechaEjecucion: $fechaEjecucion
              ) {
                procesoj {
                  id
                  fechaProgramada
                }
              }
            }
          `;

          const variables = {
            tokenProceso: this.tokenProceso.toString(),
            fechaEjecucion: this.fechaEjecucion.toString(),
          };

          try {
            const response = await axios.post(rutas.axios + "api", { query, variables });

            if (response.data.errors) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
              });

              return;
            }

            await this.$swal({
              icon: "success",
              title: "Éxito",
              text: "La fecha se actualizó correctamente.",
            });

            this.$router.go(0);

          } catch (error) {
            console.error(error);
          }
        }
      }
    },

    
  },

  watch: {

    '$route.query.exe': {
      immediate: true,
      handler() {
        this.getData();
      }
    }
  }
}
</script>
